module.exports = __webpack_public_path__ + "img/32.6.CODm.8f07301f.png";